<template>
  <div>
    <ExSelectPicker
      :pickerLabel="pickerLabel"
      :label="label"
      :searchLabel="searchLabel"
      :items="processedCurrencies"
      :value="modelValue"
      :useCode="useCode"
      :isSelectedItemRemove="isSelectedItemRemove"
      @item-selected="handleItemSelected"
      @clear-selection="clearItemSelected"
      :isforceReadonly="isforceReadonly"
      :isShowDefautValue="isShowDefautValue"
      :defaultCurrencyProp="defaultCurrency?.code || ''"
      noRecordMessage="No currency found"
      @input-cleared="clearItemSelected"
    />
  </div>
</template>

<script setup>
import ExSelectPicker from "@components/SelectPicker/ExSelectPicker.vue";
import { defineProps, defineEmits, onMounted, ref, computed, getCurrentInstance } from "vue";
import { getListOfCurrencies } from "@/api";

const app = getCurrentInstance();
const { proxy } = app;

const props = defineProps({
  modelValue: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  items: {
    required: false,
    type: Array,
    default() {
      return []
    }
  },
  pickerLabel: {
    type: String,
    required: false,
    default: "Search Currency",
  },
  label: {
    type: String,
    required: false,
    default: "Select Currency",
  },
  searchLabel: {
    type: String,
    required: false,
    default: "Search Currency",
  },
  useCode: {
    type: Boolean,
    required: false,
    default: true,
  },
  isSelectedItemRemove: {
    type: Boolean,
    required: false,
    default: false,
  },
  isforceReadonly: {
    type: Boolean,
    default: false,
  },
  isShowDefautValue: {
    type: Boolean,
    default: false,
  },
  pickerPopUp: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue"]);

const currencies = ref([]);
const defaultCurrency = ref(null);

const processedCurrencies = computed(() => {
  const storedCurrency = JSON.parse(localStorage.getItem("referenceCurrency"));
  
  // Use items prop if it has values, otherwise use fetched currencies
  const currencySource = props.items.length > 0 ? props.items : currencies.value;
  
  return currencySource.map(currency => {
    if (storedCurrency && currency.id === storedCurrency) {
      defaultCurrency.value = currency;
    } else if (!storedCurrency && currency.code === 'USD') {
      defaultCurrency.value = currency;
    }    // Check if this currency exists in items prop with disabled=true
    const disabledItem = props.items.find(item => 
      item.id === currency.id && item.disabled === true
    );

    return {
      ...currency,
      disabled: disabledItem ? true : currency.disabled,
      countries: currency.countries?.map(country => ({
        ...country,
        flag_icon: country.flag_icon && !props.pickerPopUp ? `${process.env.VUE_APP_BASE_URL}${country.flag_icon}` : `${country.flag_icon}`
      })).sort((a, b) => b.name.localeCompare(a.name))
    };
  });
});

onMounted(() => {
  if (!props.pickerPopUp) {
    fetchCurrencies();
  }
});

const handleItemSelected = (selectedItem) => {
  emit("item-currency-selected", selectedItem);
};

const clearItemSelected = () => {
  if(props.pickerPopUp){
    handleItemSelected(null);
  }
  emit("clear-selection")
};


const fetchCurrencies = async () => {
  try {
    proxy.$loader.show();
    const response = await getListOfCurrencies();
    currencies.value = response.data.results;
  } catch (error) {
    console.error('Error fetching currencies:', error);
  } finally {
    proxy.$loader.hide();
  }
}
</script>

<style scoped>
::v-deep(.selected-currency-icon img) {
  height: 100% !important;
  width: 100% !important;
  object-fit: cover !important;
  margin-left: 0px !important;
  z-index: 1;
}

::v-deep(.v-avatar) {
    overflow: none !important;
}

::v-deep .custom-response-picker { 
  width: 100%;
}

.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100px;
  gap: 12px;
}

.loading-text {
  margin: 0;
  font-size: 14px;
  color: #666;
  text-align: center;
}
</style>
